import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  Form,
  TextInput,
  required,
  CheckboxGroupsInput,
  BooleanInput,
} from '../components';
import PersonalInfoInput from './personalInfoInput';
import { get } from 'lodash';
import { canDistinguish } from '@ivymobi/orbit-core/util/fileType';
import { useTranslation } from 'react-i18next';


export default function ShareForm (props) {
  const { onSubmit, downloadable, documents, selectedId } = props;
  if (!!documents && !!selectedId.length) {
    const sid = selectedId[0];
    const selectMessage = documents[sid];
    const canDownload = selectMessage?.acl?.downloadable === undefined? true : selectMessage?.acl?.downloadable;
    var [t] = useTranslation();
     const triggerTime = [
      { id: 'view', value: 'view', label: t('YBT-ADMIN.YBT-ADMIN-050102.YBT-ADMIN-05010226') },
      // { id: 'fav', value: 'fav', label: '收藏文件时' },
      { id: 'download', value: 'download', label: t('YBT-ADMIN.YBT-ADMIN-050102.YBT-ADMIN-05010228') },
      { id: 'share', value: 'share', label: t('YBT-ADMIN.YBT-ADMIN-050102.YBT-ADMIN-05010227') }
    ];
    return ( <Form onSubmit={onSubmit}>
      <Typography style={{ marginTop: '24px' }} gutterBottom>{t('common.share')}</Typography>
      <TextInput name='name' label={t('common.sharingTopics')} validate={[required()]} fullWidth />
      <PersonalInfoInput />
      <CheckboxGroupsInput options={triggerTime} name='eoi' label={t('common.momentofSubmitting')} row />
      <Box p={0.5} />
      {/* {canDistinguish(selectMessage.type, get(selectMessage, 'asset.filename'))&&<BooleanInput disabled={!canDownload} name='acl.downloadable' title='是否允许下载' />} */}
      {/* {canDistinguish(selectMessage.type, selectMessage.name)&&<BooleanInput disabled={!canDownload} name='acl.downloadable' title='是否允许下载' />} */}
      {canDistinguish(selectMessage.type, get(selectMessage, 'asset.filename'))&&<BooleanInput disabled={!canDownload} name='acl.downloadable' title={t('common.allowDownloads')} />}
    </Form>);
  }
  var [t] = useTranslation();
  const triggerTime = [
    { id: 'view', value: 'view', label: t('YBT-ADMIN.YBT-ADMIN-050102.YBT-ADMIN-05010226') },
    // { id: 'fav', value: 'fav', label: '收藏文件时' },
    { id: 'download', value: 'download', label: t('YBT-ADMIN.YBT-ADMIN-050102.YBT-ADMIN-05010228') },
    { id: 'share', value: 'share', label: t('YBT-ADMIN.YBT-ADMIN-050102.YBT-ADMIN-05010227') }
  ];
  return (
    <Form onSubmit={onSubmit}>
      <Typography style={{ marginTop: '24px' }} gutterBottom>{t('common.share')}</Typography>
      <TextInput name='name' label={t('common.sharingTopics')} validate={[required()]} fullWidth />
      <PersonalInfoInput />
      <CheckboxGroupsInput options={triggerTime} name='eoi' label={t('common.momentofSubmitting')} row />
      <Box p={0.5} />
      <BooleanInput disabled={downloadable === undefined ? false : !downloadable} name='acl.downloadable' title={t('YBT-ADMIN.YBT-ADMIN-020103.YBT-ADMIN-02010308')} />

    </Form>
  );
}
